import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { ICommendaProductTaxCode } from './types';

export function useSalesTaxProductTaxCodes({
  token,
  filters,
}: {
  token: string;
  filters: {
    corporationId: number;
  };
}) {
  const query = new URLSearchParams();

  if (filters.corporationId) {
    query.append('corporationId', filters.corporationId.toString());
  }

  const {
    data,
    mutate,
    error,
  }: {
    data: {
      data: {
        taxCodes: ICommendaProductTaxCode[];
      };
    };
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
  } = useSWR(
    `new-sales-tax/products/taxCodes?${query}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data: data?.data?.taxCodes,
    mutate,
    error,
  };
}
